module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Salinas-62db1bd7fcdf6d8313c601242e2d40da.jpg";